"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GravityGatewayAdapter = void 0;
var lodash_1 = require("lodash");
var seven_gravity_gateway_1 = require("@nsftx/seven-gravity-gateway");
var Utility_1 = require("./Utility");
var Registry_1 = require("./Registry");
var Types_1 = require("./Types");
var GravityGatewayAdapter = /** @class */ (function () {
    function GravityGatewayAdapter(options) {
        this.options = options;
        if ((0, lodash_1.isNil)(this.options.slaveId)) {
            throw new Error(Types_1.ConfigurationErrors.MissingSlaveIdError);
        }
    }
    GravityGatewayAdapter.prototype.getConfiguration = function () {
        if (seven_gravity_gateway_1.slave) {
            this.gateway = new seven_gravity_gateway_1.slave({
                allowedOrigins: this.options.allowedOrigins,
                debug: this.options.isDebug,
                slaveId: this.options.slaveId,
                eventPropagation: this.options.eventPropagation,
                eventListeners: this.options.eventListeners,
                plugins: this.options.plugins,
                load: this.onLoad.bind(this),
            });
            (0, lodash_1.assign)(Registry_1.registry.messageProtocols.gravityGateway, {
                handler: this.gateway,
            });
        }
        this.setWebView();
    };
    GravityGatewayAdapter.prototype.getUserLocale = function (user) {
        if (user) {
            if (user.profile) {
                return user.profile.language;
            }
            return user.language;
        }
        return undefined;
    };
    GravityGatewayAdapter.prototype.getUserTimezone = function (user) {
        if (user) {
            if (user.profile) {
                return user.profile.timezone;
            }
            return user.timezone;
        }
        return undefined;
    };
    GravityGatewayAdapter.prototype.getCompanyProductId = function (company) {
        if (company && company.config) {
            return company.config.cpvUuid;
        }
        return undefined;
    };
    GravityGatewayAdapter.prototype.getCompanyTimezoneOffset = function (company) {
        if (company && company.config) {
            return company.config.timezoneOffset;
        }
        return 0;
    };
    GravityGatewayAdapter.prototype.parseUser = function (user) {
        if (user) {
            var accessToken = void 0;
            var refreshToken = void 0;
            if (user.auth) {
                accessToken = (0, lodash_1.defaultTo)(user.auth.accessToken, user.auth.token);
                refreshToken = user.auth.refreshToken;
            }
            return {
                id: (0, lodash_1.defaultTo)(user.id, user.uuid),
                username: (0, lodash_1.defaultTo)(user.name, user.username),
                email: user.email,
                firstName: user.firstName,
                lastName: user.lastName,
                balance: (0, Utility_1.defaultToAny)(user.balanceTotal, user.balance, 0),
                token: (0, lodash_1.defaultTo)(user.token, accessToken),
                tokenType: Types_1.TokenType.Bearer,
                timezone: this.getUserTimezone(user),
                refreshToken: refreshToken,
            };
        }
        return user;
    };
    GravityGatewayAdapter.prototype.setWebView = function () {
        var _this = this;
        var webViewHandler = function (action, payload) {
            var cleanMessage = JSON.stringify(payload);
            var message = JSON.parse(cleanMessage);
            _this.onLoad(message);
        };
        (0, lodash_1.assign)(window, {
            onParentMessage: webViewHandler,
        });
    };
    GravityGatewayAdapter.prototype.onLoad = function (message) {
        var payload = message.data;
        var betslip = (0, lodash_1.defaultTo)((0, lodash_1.get)(payload, 'betslip'), undefined);
        var company = (0, Utility_1.defaultToAny)((0, lodash_1.get)(payload, 'company'), (0, lodash_1.get)(payload, 'tenant'), {});
        var product = (0, Utility_1.defaultToAny)((0, lodash_1.get)(payload, 'product'), (0, lodash_1.get)(payload, 'account'), {});
        var user = (0, lodash_1.defaultTo)((0, lodash_1.get)(payload, 'user'), undefined);
        var channel = (0, lodash_1.defaultTo)((0, lodash_1.get)(payload, 'dp'), undefined);
        var betshop = (0, lodash_1.defaultTo)((0, lodash_1.get)(payload, 'betshop'), {});
        var device = (0, Utility_1.defaultToAny)((0, lodash_1.get)(payload, 'device'), betshop.device, {});
        var integration = (0, lodash_1.defaultTo)((0, lodash_1.get)(payload, 'integration'), undefined);
        var language = (0, lodash_1.defaultTo)((0, lodash_1.get)(payload, 'locale'), {});
        var settings = (0, lodash_1.defaultTo)((0, lodash_1.get)(payload, 'settings'), {});
        var scrollButtons = (0, lodash_1.defaultTo)((0, lodash_1.get)(settings, 'scrollButtons'), undefined);
        var moneyDenominations = (0, lodash_1.defaultTo)((0, lodash_1.get)(settings, 'moneyDenominations'), undefined);
        var environment = (0, Utility_1.defaultToAny)(payload.environment, payload.env, undefined);
        var platformName = Registry_1.registry.platforms.seven.name;
        var platformDataCenter = (0, Utility_1.defaultToAny)(payload.platformDataCenter, payload.platformDc, undefined);
        var productName = (0, Utility_1.defaultToAny)(product.id, undefined);
        var productId = (0, Utility_1.defaultToAny)(product.cpvUuid, product.linkId, this.getCompanyProductId(company), undefined);
        var productUuid = (0, Utility_1.defaultToAny)(product.uuid, undefined);
        var tenantId = (0, Utility_1.defaultToAny)(company.uuid, company.id, undefined);
        var locale = (0, Utility_1.defaultToAny)(language.iso1, payload.language, company.language, this.getUserLocale(user), undefined);
        var applicationName = (0, Utility_1.defaultToAny)(payload.applicationName, payload.appName, payload.app, undefined);
        var channelId = (0, Utility_1.defaultToAny)(channel, undefined);
        var betshopId = (0, Utility_1.defaultToAny)(betshop.uuid, undefined);
        var deviceId = (0, Utility_1.defaultToAny)(device.uuid, undefined);
        var isIntegration = (0, Utility_1.defaultToAny)(integration, undefined);
        var event = new CustomEvent('Configuration:SetConfiguration', {
            detail: {
                environment: environment,
                platformName: platformName,
                platformDataCenter: platformDataCenter,
                productName: productName,
                productId: productId,
                productUuid: productUuid,
                tenantId: tenantId,
                locale: locale,
                applicationName: applicationName,
                channelId: channelId,
                betshopId: betshopId,
                deviceId: deviceId,
                isIntegration: isIntegration,
                betslip: betslip,
                scrollButtons: scrollButtons,
                moneyDenominations: moneyDenominations,
                user: this.parseUser(user),
            },
        });
        window.dispatchEvent(event);
    };
    return GravityGatewayAdapter;
}());
exports.GravityGatewayAdapter = GravityGatewayAdapter;
//# sourceMappingURL=GravityGatewayAdapter.js.map